module.exports = __webpack_public_path__ + "assets/52bb80b5b862c2c2e70b1fa164fb4def.jpg";